import { cellRenderParseData, cellRenderStatus } from '../../utils/functions';
import { cellRenderButtonModalSK } from '../ModalSK/functionModalSK';

const columnDataGridPiece = [
  {
    dataField: 'qcId',
    caption: '№ СК',
    dataType: 'string',
    cellRender: cellRenderButtonModalSK
    // cssClass: 'td-button-cell-render'
  },
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус УЕ',
    cellRender: cellRenderStatus,
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    dataType: 'string'
  },
  {
    dataField: 'weight',
    caption: 'Вес',
    dataType: 'number'
  }
];

export default columnDataGridPiece;
